import { get } from 'lodash'

// CSP-compliant mustache-style interpolation (no eval)
export const interpolate = (template: string, values: Record<string, unknown>) => {
  return template.replace(/\{\{\s*([\w]+)\s*\}\}/g, (_, key) => String(values[key] ?? ''));
};

// Transform an object into a "translation" function that accept string args

function createTranslationFunc(dict, { prefix = '' } = {}) {
  return function translate(key, args = {}) {
    const fullKey = prefix ? prefix + '.' + key : key
    const translation = get(dict, fullKey)

    if (!translation) {
      // eslint-disable-next-line
      console.warn(`No translation found for key: '${fullKey}'`)
      // Return placeholder so we know it's missing.
      return '<' + fullKey + '>'
    }
    if (typeof translation === 'object') return translation
    return interpolate(translation, args)
  }
}

export default createTranslationFunc
